import {Injectable} from '@angular/core';
import {UsersService} from '../api/services/users.service';
import {SoftphoneService as SoftphoneApiService} from '../api/services/softphone.service';
import {PbxService} from '../api/services/pbx.service';
import { HttpClient } from '@angular/common/http';
import {AuthService} from '../core/security/auth.service';
import {SoftPhoneSummaryModel} from '../api/models/soft-phone-summary-model';
import {DownloadLinkModel} from '../api/models/download-link-model';
import {SoftPhoneChangePasswordModel} from '../api/models';

@Injectable()
export class SoftPhoneService {

  constructor(private apiUserService: UsersService,
              private apiPbxService: PbxService,
              private httpClient: HttpClient,
              private authService: AuthService,
              private softphoneApiService: SoftphoneApiService
  ) {

  }

  async getSoftphoneSummary(): Promise<SoftPhoneSummaryModel> {

    const summary = await this.softphoneApiService.softphoneSummary()
      .toPromise();

    return summary;
  }

  async getSoftphoneLinks(): Promise<Array<DownloadLinkModel>> {

    const links = await this.softphoneApiService.softphoneDownloadLinks()
      .toPromise();

    return links;
  }

  async changeSoftPhonePassword(model: SoftPhoneChangePasswordModel): Promise<boolean> {
    await this.softphoneApiService.softphoneChangePassword({body: model})
      .toPromise();

    return true;
  }
}
